import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useBreakpoint = () => {
  const { breakpoints } = useTheme();

  return {
    isDesktop: useMediaQuery(breakpoints.up('lg')),
    isMobile: useMediaQuery(breakpoints.down('sm')),
    isTablet: useMediaQuery(breakpoints.between('sm', 'lg')),
  };
};
